// The one ceiling for a file colleagues bring into ECONIC (3 Nov 2026, the Ministry's sandbox feedback: "the system does not accept files
// larger than 25 MB"): 200 MB, the Knowledge Bank's own. The same numbers as UploadLimits in
// services/src/Ncp.Application/Abstractions/UploadLimits.cs; a unit test there keeps the two equal.

/** The largest file, in megabytes (MiB, as the size a browser reports is counted). */
export const MAX_UPLOAD_MB = 200;
/** The largest file, in bytes: chat attachments, Knowledge Bank uploads, the waitlist's contributions. */
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
/** The part size of a resumable upload. */
export const UPLOAD_PART_BYTES = 5 * 1024 * 1024;
/** Files up to this size are sent in one request; larger ones in parts, so no proxy in front of the API carries a 200 MB body. */
export const SINGLE_POST_MAX_BYTES = 20 * 1024 * 1024;
